import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { usePageMeta } from '@/utils/usePageMeta'

// SEO Section Constants
export const SEO_PAGE = {
  CASES: 'CASES',
  GIVEAWAYS: 'GIVEAWAYS',
  EVENTS: 'EVENTS',
  TIDES_OF_WAR: 'TIDES_OF_WAR',
  DAILY_FREE: 'DAILY_FREE',
  ARCADE: 'ARCADE',
  ARCADE_PRICE_GUESS: 'ARCADE_PRICE_GUESS',
  ARCADE_MEMORY: 'ARCADE_MEMORY',
  CASE_DETAIL: 'CASE_DETAIL',
} as const

export type SeoPage = (typeof SEO_PAGE)[keyof typeof SEO_PAGE]

/**
 * Composable for setting up SEO meta tags from i18n translations
 * @param sectionKey - The SEO_SECTIONS key (e.g., SEO_PAGE.CASES)
 * @param ogType - The Open Graph type (default: 'website')
 */
export function useSeoMeta(sectionKey: SeoPage, ogType: string = 'website') {
  const { t } = useI18n()

  const metaTitle = computed(() => t(`SEO_SECTIONS.${sectionKey}.metaTitle`))
  const metaDescription = computed(() => t(`SEO_SECTIONS.${sectionKey}.metaDescription`))

  usePageMeta({
    title: metaTitle,
    description: metaDescription,
    ogType,
  })
}
